import {
  arcsitePlatformPattern,
  arcsiteVersionPattern,
  ardVersionPattern,
  iosPattern,
  mobilePattern,
} from './consts';

const userAgent = typeof window === 'object' ? window.navigator.userAgent : '';

export function isMobile() {
  return mobilePattern.test(userAgent);
}

export function isAndroid() {
  return ardVersionPattern.test(userAgent);
}

export function isIos() {
  return iosPattern.test(userAgent);
}

export function isIpadOS() {
  return (
    Boolean(
      navigator.maxTouchPoints &&
        navigator.maxTouchPoints > 2 &&
        navigator.platform.includes('MacIntel')
    ) || navigator.platform.includes('iPad')
  );
}

interface AppInfo {
  isInApp: boolean;
  platform: string | null;
  isCrossPlatform: boolean;
  version: string | null;
}
export function getAppInfo(_userAgent: string = userAgent): AppInfo {
  const matcher = _userAgent.match(arcsiteVersionPattern);
  const platformMatcher = _userAgent.match(arcsitePlatformPattern);

  let appInfo: AppInfo = {
    isInApp: false,
    platform: null,
    isCrossPlatform: false,
    version: null,
  };

  if (matcher) {
    const version = matcher[1];
    appInfo = { ...appInfo, isInApp: true, version };
  }
  if (platformMatcher) {
    const platform = platformMatcher[1];
    appInfo = {
      ...appInfo,
      platform,
      isCrossPlatform: platform === 'android' || platform === 'windows',
    };
  }
  return appInfo;
}

export function isInApp(_userAgent?: string) {
  return getAppInfo(_userAgent).isInApp;
}

function compareVersions(v1: string, v2: string): number {
  const v1Parts = v1.split('.').map(Number);
  const v2Parts = v2.split('.').map(Number);

  for (let i = 0; i < Math.max(v1Parts.length, v2Parts.length); i++) {
    const v1Part = v1Parts[i] || 0;
    const v2Part = v2Parts[i] || 0;

    if (v1Part > v2Part) return 1;
    if (v1Part < v2Part) return -1;
  }

  return 0;
}

/**
 * GTE: Greater Than or Equal to (大于等于)
 */
export function isAppVersionGTE(targetVersion: string): boolean {
  const appInfo = getAppInfo();
  if (!appInfo.isInApp || !appInfo.version) return false;

  return compareVersions(appInfo.version, targetVersion) >= 0;
}
